import { useMemo } from 'react';

import { GridEntityConfig } from '../grid-types';
import { useLevelIndex } from './level-index-hook';

export const useBodyButtons = (gridConfig?: GridEntityConfig[]) => {
  const levelIndex = useLevelIndex(gridConfig);

  return useMemo(() => {
    if (levelIndex === undefined || !gridConfig) {
      return [];
    }

    const bodyButtons = gridConfig[levelIndex]?.bodyButtons ?? [];

    return bodyButtons;
  }, [gridConfig, levelIndex]);
};
